const staticData = {
    static: {
        sections: [
            {
                title: 'Top Searches',
                slug: 'top-searches',
                searches: [
                    {
                        title: 'disney',
                    },
                    {
                        title: 'golf',
                    },
                    {
                        title: 'toy story',
                    },
                    {
                        title: 'tennis',
                    },
                    {
                        title: 'swim',
                    },
                    {
                        title: 'robe',
                    },
                    {
                        title: 'frozen',
                    },
                    {
                        title: 'pizza',
                    },
                    {
                        title: 'kimono',
                    },
                    {
                        title: 'lobster',
                    },
                    {
                        title: 'moana',
                    },
                ],
            },
            {
                title: 'Top Classes + Events',
                slug: 'top-classes-events',
                classes: [
                    {
                        title: 'Baby + Me Yoga',
                        url: '/products/baby-me-yoga-busy-little-babies-grown-up-yoga',
                    },
                    {
                        title: 'Baby Bandstand',
                        url: '/products/baby-bandstand',
                    },
                    {
                        title: 'Busy Little Yogis',
                        url: '/products/busy-little-yogis',
                    },
                    {
                        title: 'Perinatal Yoga with Carla Jian',
                        url: '/products/perinatal-yoga-with-carla-jian',
                    },
                    {
                        title: 'Infant First Aid + CPR',
                        url: '/products/in-person-infant-cpr-chicago-nyc',
                    },
                    {
                        title: 'Songs + Stories With Bubbles Academy',
                        url: '/products/songs-stories-with-bubbles-academy',
                    },

                ],
            },
            {
                title: 'Top Categories',
                slug: 'top-categories',
                categories: [
                    {
                        title: 'Rompers + Bodysuits',
                        url: '/collections/all-rompers',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-rompers-bodysuits.webp?v=1750127369',
                        imageAlt: 'Zipper One-Piece in Milk N Cookies print',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Blankets',
                        url: '/collections/baby-blankets-swaddles',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-blankets.webp?v=1750127369',
                        imageAlt: 'Coming Home Blanket in Navy Outerspace print',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Dresses',
                        url: '/collections/all-dresses',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-dresses.webp?v=1750127369',
                        imageAlt:
                            "Short Sleeve Let's Dance Dress in Puppy Bffs print",
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Pajamas',
                        url: '/collections/all-pajamas',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-pajamas.webp?v=1750127369',
                        imageAlt:
                            'Two-Piece Shorty Pajama Set in Lobster Claws print',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Gifts + Sets',
                        url: '/collections/baby-gifts',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-gifts-sets.webp?v=1750127369',
                        imageAlt: 'Baby 3-Piece Knit Set in Cream Heather',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Nursery',
                        url: '/collections/nursery',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-dresser.webp?v=1750127369',
                        imageAlt: 'Bondi 6-Drawer Assembled Dresser in Honey',
                        vendor: 'Bondi'
                    },
                    {
                        title: 'Accessories',
                        url: '/collections/all-accessories',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-accessories.webp?v=1750127369',
                        imageAlt: "7-Pack Girl's Underwear in Disney Princess print",
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Robes',
                        url: '/collections/organic-lounge-robes',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-flyout-maternity-organic-lounge-robe-grey_600x600.jpg?v=1694013760',
                        imageAlt:
                            'Organic Lounge Robe in grey folded with a bow',
                        vendor: 'Monica + Andy'
                    }
                ],
            },
        ],
    },
}

export default staticData
